import { style } from '@do/walrus';

import defaultsDeep from 'lodash/defaultsDeep';
import defaultBg from './assets/backgrounds/HeroBackground-Option1-01.png';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';
import defaultBg3 from './assets/backgrounds/HeroBackground-Option3-01.png';

import premCpuBg from './assets/backgrounds/Prem_CPU_bg.jpg';
import managedKafkaBg from './assets/backgrounds/managedKafka.jpg';
import premiumGpDropletsBg from './assets/backgrounds/premium-droplets-bg.jpg';
import scalableStorageBg from './assets/backgrounds/scalableStorageBg.jpg';
import whatIsNewBg from './assets/backgrounds/whatIsNew.jpg';
import droplet from './assets/droplet.svg';
import cloudwaysBg from './assets/partners/cloudways/cloudways_bg.jpg';
import cloudwaysLogo from './assets/partners/cloudways/cloudways_logo.png';
import deployBg from './assets/partners/deploy/deploy_bg.png';
import deployLogo from './assets/partners/deploy/deploy_logo.png';
import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';
import paperspaceBg from './assets/partners/paperspace/paperspace_bg.png';
import paperspaceLogo from './assets/partners/paperspace/paperspace_logo.svg';
import { GROWTH_ENG_GHSP_OFFER_UPGRADE } from './constants';
import copy from './copy';

import {
  ButtonVariations,
  DynamicVariantProps,
  VariantMap,
  VariantProps
} from './interfaces/variant';

export const defaultVariant: VariantProps = {
  type: 'defaultVariant1',
  textColor: 'white',
  background: {
    color: style.colors.grey.lightest,
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center',
    height: '180px',
    width: '360px'
  },
  splash: {
    background: {
      image: defaultBg2
    },
    title: {
      text: 'Welcome to DigitalOcean!',
      sizeDesktop: '2rem'
    },
    subtitle: {
      text: 'Sign up for an account to get started.'
    },
    textColor: style.colors.white
  },
  title: copy.form.login_title,
  subtitle: ''
};

export const defaultDynamicVariant: DynamicVariantProps = {
  id: 1,
  type: 'defaultVariant1',
  splash: {
    background: {
      url: defaultBg2
    },
    title: {
      text: 'Welcome to DigitalOcean!',
      color: 'light'
    },
    subtitle: {
      text: 'Sign up for an account to get started.',
      color: 'light'
    }
  },
  loginTitle: copy.form.login_title,
  loginSubtitle: ''
};

export const defaultVariant2: VariantProps = defaultsDeep(
  {
    type: 'defaultVariant2',
    background: {
      image: defaultBg2
    }
  },
  defaultVariant
);

export const defaultVariant3: VariantProps = defaultsDeep(
  {
    type: 'defaultVariant3',
    background: {
      image: defaultBg3
    }
  },
  defaultVariant
);

export const teamVariant: VariantProps = defaultsDeep(
  {
    type: 'teamVariant',
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{name}} has invited you to join them. Sign in and start making waves with your team today!'
  },
  defaultVariant
);

export const githubLoginVariant: VariantProps = defaultsDeep(
  {
    type: 'githubStudentPack',
    title: 'Log into your account',
    preferredLoginTitle: 'Log into your account',
    subtitle:
      'In order to claim your credits please log in to your DigitalOcean account',
    preferredLoginSubtitle: 'In order to claim your credits please log in',
    splash: {
      background: {
        image: ghStudentBg
      },
      logo: {
        image: ghStudentLogo
      },
      title: {
        text: 'GitHub Student Developer Pack'
      },
      subtitle: {
        text: `As a part of GitHub student developer pack, you will receive ${
          GROWTH_ENG_GHSP_OFFER_UPGRADE
            ? '$200' /* eslint-disable-line @do/no-hardcoded-prices */
            : '$100' /* eslint-disable-line @do/no-hardcoded-prices */
        } in credit that are valid for 1 year. Once you sign up you will be prompted to verify your GitHub account`
      },
      textColor: style.colors.grey.darkest,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Learn more',
        fullWidth: true,
        url: 'https://education.github.com/pack?utm_source=github+digitalocean'
      }
    }
  },
  defaultVariant
);

export const deployVariant = defaultsDeep(
  {
    type: 'deploy',
    splash: {
      background: {
        image: deployBg
      },
      logo: {
        image: deployLogo,
        width: '250px'
      },
      title: {
        text: 'November 15-16, 2022',
        color: '#420003'
      },
      subtitle: {
        text: (
          <>
            Learn from developers and founders who've been there, built that
            <br />
            <br />
            #DOdeploy
          </>
        ),
        color: style.colors.white
      },
      button: {
        buttonColor: {
          background: '#420003',
          hoverBackground: '#600105'
        },
        text: 'RSVP for Free',
        fullWidth: true,
        url: 'https://deploy.digitalocean.com/?utm_medium=cloud&utm_source=login&utm_content=content'
      }
    }
  },
  defaultVariant
);

export const cloudwaysVariant = defaultsDeep(
  {
    type: 'cloudways',
    splash: {
      background: {
        image: cloudwaysBg,
        width: '720px'
      },
      paddingX: '30px',
      logo: {
        image: cloudwaysLogo
      },
      title: {
        text: 'DigitalOcean now offers Managed Hosting',
        sizeDesktop: '1.4rem',
        sizeMobile: '1.25rem'
      },
      subtitle: {
        text: 'Hassle-free managed website hosting is now part of DigitalOcean! With Cloudways, you get an optimized PHP stack for high performance, application-level support at any time, and proactively managed updates and patches to give you peace of mind, so you can focus on growing your business.',
        sizeDesktop: '1rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.SECONDARY,
        /* eslint-disable-next-line @do/no-hardcoded-prices */
        text: 'Start free with a $100 credit',
        fullWidth: false,
        url: 'https://www.cloudways.com/en/managed-hosting-for-digital-ocean.php?id=1227504&utm_source=cloud.digitalocean.com&utm_medium=referral&utm_campaign=gen-do-pl-pf-lopc&data1=platform&data2=gen-do-pl-pf-lopc'
      }
    }
  },
  defaultVariant
);

export const premCpuVariant = defaultsDeep(
  {
    type: 'cloudways',
    splash: {
      background: {
        image: premCpuBg,
        width: '720px'
      },
      title: {
        text: 'New! Premium CPU-Optimized \n Droplets are now available',
        sizeDesktop: '2rem',
        sizeMobile: '1.25rem'
      },
      subtitle: {
        text: 'Premium CPU-Optimized Droplets, virtual machines built for high network throughput and powerful performance are now generally available.\n \n Powered by Intel® Xeon® processors, these Droplets feature up to 10Gbps outbound network speeds, superfast NVMe storage and dedicated vCPUs.',
        sizeDesktop: '1.25rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Curious? Read on',
        fullWidth: false,
        url: 'https://www.digitalocean.com/blog/introducing-premium-cpu-optimized-droplets?utm_medium=cloud&utm_source=login&utm_content=content'
      }
    }
  },
  defaultVariant
);

export const paperspaceVariant = defaultsDeep(
  {
    type: 'paperspace',
    splash: {
      background: {
        image: paperspaceBg,
        width: '720px'
      },
      logo: {
        image: paperspaceLogo,
        margin: '0 0 32px 0',
        width: '300px'
      },
      title: {
        text: 'Develop, train, and deploy AI models using blazing fast ⚡ GPUs',
        sizeDesktop: '1.4rem',
        sizeMobile: '1.25rem'
      },
      subtitle: {
        text: `Run your AI-powered business or app in the cloud with high-performance compute that's as simple to use as it is powerful.`,
        sizeDesktop: '1rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.PRIMARY,
        text: 'Learn more about Paperspace',
        fullWidth: false,
        url: 'https://www.paperspace.com/?utm_medium=referral&utm_source=do&utm_content=login-banner',
        buttonColor: {
          background: style.colors.white,
          hoverBackground: style.colors.black
        },
        textColor: {
          color: style.colors.black,
          hoverColor: style.colors.white
        }
      }
    }
  },
  defaultVariant
);

export const managedKafkaVariant = defaultsDeep(
  {
    type: 'managedKafkaVariant',
    splash: {
      background: {
        image: managedKafkaBg
      },
      title: {
        text: 'Try DigitalOcean Managed Kafka today!',
        sizeDesktop: '2rem'
      },
      subtitle: {
        text: `DigitalOcean Managed Kafka, a fully managed event streaming platform as a service, removes the complexities associated with self-managing Kafka and has an all-inclusive, flat-rate pricing model starting at just $147/month to help you avoid unexpected costs.`,
        sizeDesktop: '1rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Tell me more about Managed Kafka!',
        url: 'https://www.digitalocean.com/blog/introducing-digitalocean-managed-kafka'
      }
    }
  },
  defaultVariant
);

export const whatIsNewVariant = defaultsDeep(
  {
    type: 'whatIsNew',
    splash: {
      background: {
        image: whatIsNewBg
      },
      title: {
        text: "What's new and what's next at DigitalOcean",
        sizeDesktop: '2rem'
      },
      subtitle: {
        text: `Read all about our latest product enhancements, starting with Managed Kafka, more Droplet choices, GPU's for AI/ML apps, and get a sneak peek at the exciting product updates we’re planning this year and beyond.`,
        sizeDesktop: '1rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Tell me more',
        fullWidth: false,
        url: 'https://do.co/whats-new'
      }
    }
  },
  defaultVariant
);

export const scalableStorageVariant = defaultsDeep(
  {
    type: 'scalableStorage',
    splash: {
      background: {
        image: scalableStorageBg
      },
      title: {
        text: 'Scalable Storage for Managed Databases'
      },
      subtitle: {
        text: `MySQL and PostgreSQL Managed Database users can now increase disk storage without needing to upgrade compute and memory, adding more flexibility to accommodate a growing data footprint.`,
        sizeDesktop: '1rem'
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.SECONDARY,
        text: 'Get Started With Scalable Storage',
        url: 'https://www.digitalocean.com/blog/introducing-digitalocean-scalable-storage'
      }
    }
  },
  defaultVariant
);

export const premiumGpDroplets: VariantProps = defaultsDeep(
  {
    type: 'premiumGpDroplets',
    splash: {
      background: {
        image: premiumGpDropletsBg
      },
      logo: {
        image: droplet,
        width: '80px',
        margin: '0 0 32px 0'
      },
      title: {
        text: 'New! Speed up your apps and websites with Premium General Purpose Droplets'
      },
      subtitle: {
        text: `Deliver stunning product and service experiences to your customers with Premium General Purpose Droplets. Equipped with powerful Intel® Xeon® CPUs, up to 10 Gbps outbound network speeds and NVMe SSDs, these virtual machines with a balanced vCPU and memory ratio of 1:4 provide the flexibility to scale your apps and websites as your business evolves.`
      },
      textColor: style.colors.white,
      button: {
        variation: ButtonVariations.PRIMARY,
        text: 'Tell me more',
        url: 'https://www.digitalocean.com/blog/introducing-premium-general-purpose-droplets',
        buttonColor: {
          background: style.colors.white,
          hoverBackground: style.colors.black
        },
        textColor: {
          hoverColor: style.colors.white
        }
      }
    }
  },
  defaultVariant
);

// These are for randomly choosing login variants
const loginVariants: VariantMap = {
  defaultVariant,
  defaultVariant2,
  defaultVariant3
};

export default loginVariants;
